import React from 'react';
import PropTypes from 'prop-types';
import tw from 'twin.macro';
import ImageHeader from './ImageHeader';
import Layout from './Layout';
import SEO from './Seo';
import ListContent from './ListContent';

export default function ListingPage({
  cover,
  list,
  title,
  subtitle,
  linkPrefix,
}) {
  return (
    <Layout>
      <SEO
        title={title}
        description={subtitle}
        fluid={cover.childImageSharp.fluid}
      />
      <ImageHeader
        fluid={cover.childImageSharp.fluid}
        title={title}
        subtitle={subtitle}
        size="medium"
      />
      <div
        css={tw`max-w-4xl px-12 mx-8 my-12 sm:my-24 sm:px-0 xl:mx-auto xl:max-w-7xl`}
      >
        {list &&
          list.edges
            .filter(({ node }) => Boolean(node.mainImage))
            .filter(({ node }) => Boolean(node?.slug?.current))
            .map(({ node }) => (
              <ListContent
                key={node.slug.current}
                node={node}
                img={node?.mainImage?.asset.fluid}
                linkPrefix={linkPrefix || title.toLowerCase()}
              />
            ))}
      </div>
    </Layout>
  );
}

ListingPage.propTypes = {
  cover: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  linkPrefix: PropTypes.string,
  list: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          slug: PropTypes.object,
          title: PropTypes.string,
          _rawExcerpt: PropTypes.array,
        }),
      })
    ),
  }),
};
